import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSideBar } from "../context/SideBarContext";
import { getTruncatedText, } from '../user-pages/ui-helper';
import { ROUTES, STORAGE_KEYS } from "../../utils/key_helper";
import { useNavigate } from "react-router-dom";
import ChangePasswordModal from "../components/modal/ChangePasswordModal";
import jwt_decode from "jwt-decode";
const Navbar = () => {
	const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
	const { toggleSideBar } = useSideBar();
	const navigate = useNavigate();
	const token = localStorage.getItem(STORAGE_KEYS.AVFX_ADMIN_ACCESS_TOKEN);
	let username = "Admin";
	if (token) {
		try {
			const decoded = jwt_decode(token);
			username = decoded?.email || "Admin";
		} catch (error) {
			console.error("Invalid token:", error);
		}
	}
	const toggleOffcanvas = () => {
		document.querySelector(".sidebar-offcanvas").classList.toggle("active");
	};

	const handleLogout = () => {
		localStorage.removeItem(STORAGE_KEYS.AVFX_ADMIN_ACCESS_TOKEN);
		navigate(ROUTES.LOGIN);

	};

	return (
		<>
			<nav className="navbar p-0 fixed-top d-flex flex-row">
				<div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
					<Link className="navbar-brand brand-logo-mini" to="/">
						<img src={require("../../assets/images/portal_mini.png")} alt="logo" />
					</Link>
				</div>
				<div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch justify-content-end">
					<button className="navbar-toggler navbar-toggler align-self-center" type="button" style={{ border: 'none' }} onClick={() => { document.body.classList.toggle("sidebar-icon-only"); toggleSideBar(); }}	>
						<span className="mdi mdi-menu"></span>
					</button>
					<ul className="navbar-nav navbar-nav-right">
						<Dropdown align="end">
							{/* Profile button */}
							<Dropdown.Toggle as="div" className="d-flex align-items-center border-0 p-0 no-caret"    >
								<button className="profile-avtar d-flex align-items-center justify-content-center rounded-circle fw-bold text-white"  >
									{username?.charAt(0)?.toUpperCase()}
								</button>
							</Dropdown.Toggle>

							{/* Dropdown Menu */}
							<Dropdown.Menu className="shadow-sm border-0 mt-2" style={{ maxWidth: '220px', minWidth: "220px", borderRadius: "12px", padding: "8px 0", }}   >
								{/* User info header */}
								<div className="px-3 py-2  ">
									{getTruncatedText(username, 20, 'd-block  small', 'strong')}
									<span className="text-muted small">Admin</span>
								</div>
								<Dropdown.Divider className="my-1" />
								<Dropdown.Item className="d-flex align-items-center py-2" onClick={() => setShowChangePasswordModal(true)}   >
									<i className="mdi mdi-key me-2 text-warning" />
									Change Password
								</Dropdown.Item>
								<Dropdown.Divider className="my-1" />
								<Dropdown.Item className="d-flex align-items-center py-2 " onClick={handleLogout}     >
									<i className="mdi mdi-logout me-2 danger-text" />
									Log Out
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</ul>
					<button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={toggleOffcanvas}	>
						<span className="mdi mdi-format-line-spacing"></span>
					</button>
				</div>
				{showChangePasswordModal && (
					<ChangePasswordModal
						show={showChangePasswordModal}
						onClose={() => setShowChangePasswordModal(false)}
					/>
				)}
			</nav>
		</>
	);
};

export default Navbar;